import { render } from "./HomeDemo.vue?vue&type=template&id=460716cc&scoped=true"
import script from "./HomeDemo.vue?vue&type=script&lang=js"
export * from "./HomeDemo.vue?vue&type=script&lang=js"

import "./HomeDemo.vue?vue&type=style&index=0&id=460716cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460716cc"]])

export default __exports__